'use strict';
var ContentManager = require('./ContentManager-browser');

var contentManager = new ContentManager();

exports.fromRenderContext = exports.getDefault = function () {
    return contentManager;
};
